class ResetPasswordContainer {
  constructor(
    $location,
    $q,
    appConfiguration,
    appErrorHandler,
    appSession,
    passwords,
  ) {
    'ngInject';

    this.$location = $location;
    this.$q = $q;
    this.appConfiguration = appConfiguration;
    this.appErrorHandler = appErrorHandler;
    this.appSession = appSession;
    this.passwords = passwords;

    this.privacyPolicyUrl = this.appConfiguration.privacyPolicyURL;
    this.goBackUrl = '/login';
    this.error = '';
    this.loading = false;
    this.success = false;
  }
  $onInit() {
    this.goBackUrl = this.appConfiguration.photorank.login;
    if (this.refCode) {
      this._loadRef();
    }
  }
  resetPassword(newPassword, confirmNewPassword) {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The request is in progress'));
    } else {
      this.loading = true;
      result = this.appSession.resetPassword(
        this.code,
        newPassword,
        confirmNewPassword,
      )
      .then(() => {
        this.success = true;
      })
      .catch((error) => {
        this.error = error.message;
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
  validatePassword(password) {
    return this.passwords.validate(password);
  }
  _loadRef() {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The referrer is already being requested'));
    } else {
      this.loading = true;
      result = this.appSession.referrer(this.code, this.refCode)
      .then((ref) => {
        this.goBackUrl = ref.url;
      })
      .catch((error) => {
        this.appErrorHandler.handle(error, '', true);
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
}

export default {
  controller: ResetPasswordContainer,
  template: `
    <reset-password
      create="$ctrl.create"
      error="$ctrl.error"
      loading="$ctrl.loading"
      success="$ctrl.success"
      on-reset="$ctrl.resetPassword(newPassword, confirmNewPassword)"
      go-back-url="$ctrl.goBackUrl"
      privacy-policy-url="$ctrl.privacyPolicyUrl"
      validate-password="$ctrl.validatePassword(password)"
    ></reset-password>
  `,
  bindings: {
    create: '<',
    code: '@',
    refCode: '@',
  },
};
